import { render, staticRenderFns } from "./DepletionModule.vue?vue&type=template&id=ff5ee95e&"
import script from "./DepletionModule.vue?vue&type=script&lang=js&"
export * from "./DepletionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports